import React from 'react';
import InsightIndexSection from './InsightIndexSection';
import { InsightIndexEntry } from '../../types';

interface DailyRoutineChartProps {
  data: Array<InsightIndexEntry | Record<string, any>>;
  primaryColor?: string;
  secondaryColor?: string;
}

export default function DailyRoutineChart({
  data,
  primaryColor = '#0369A1',
  secondaryColor = '#14B8A6',
}: DailyRoutineChartProps) {
  return (
    <InsightIndexSection
      title="Daily Routine"
      insights={data}
      primaryColor={primaryColor}
      accentColor={secondaryColor}
      icon="⏱️"
      subtitle="BASELINE: Online Adult Population | CONTAINS: Engaged Audiences Data"
      emptyMessage="Upload a Daily Routine insight file in the admin panel to populate this section."
    />
  );
}
